export const setAppHeightVar = () => {
    const update = () => {
        document.documentElement.style.setProperty(
          '--app-height',
          `${window.innerHeight}px`
        )
      }
    
      window.addEventListener('resize', update)
      window.addEventListener('orientationchange', update)
      update()
  }